import { get } from 'svelte/store';
import { os, app } from 'src/stores/session/native-bridge';
import type { InputPropsTypes } from '@Shelly/shelly-design-system';

// Keyboard with numbers and negative sign
// 1) IOS input type="number"
// 2) Android input type="text" and inputmode='numeric'
export const getNumberInputConfig = (
	iosNumbersFirst = false,
): {
	type: InputPropsTypes['type'];
	inputmode?: string;
} => {
	const isAndroidDevice = get(os) !== 'IOS' && get(app);
	return {
		type: !isAndroidDevice && iosNumbersFirst ? 'number' : 'text',
		...(isAndroidDevice && { inputmode: 'numeric' }),
	};
};

// Restrict decimal number input after point
export const restrictDecimalNumberInput = (e: Event, symbolsAfterPoint: number): void => {
	const regex = new RegExp(`^\\d*\\.?\\d{0,${symbolsAfterPoint}}$`);
	if (!regex.test(e.target.value)) e.target.value = e.target.value.slice(0, -1);
};

// To avoid floating point precision errors with small step values (e.g., 0.0001),
// we use `addNumberStep()` to perform safe additions/subtractions based on the step precision.
export const addNumberStep = (value: number, step: number): number => {
	const precision = getDecimalPlaces(step);
	const newValue = value + step;
	return parseFloat(newValue.toFixed(precision));
};

const getDecimalPlaces = (num: number): number => {
	if (!isFinite(num)) return 0;
	const parts = num.toString().split('.');
	return parts[1]?.length || 0;
};
